export default "__VITE_PUBLIC_ASSET__a0187e4c__"